export class TicketRate {
  price: number;
  turnover: number;
  gracePeriod: Date;
}
